import React from "react";
import { Container, Row, Col } from "shards-react";
import DebitNote from "../components/invoicing/DebitNote";

const DebitNoteView = props => {
  const { id, invoice_id } = props.match.params;
  return (
    <Container fluid className="main-content-container px-4">
      <Row>
        <Col className="p-2">
          <DebitNote id={id} invoice_id={invoice_id} />
        </Col>
      </Row>
    </Container>
  );
};

export default DebitNoteView;
